import { handleActions } from 'redux-actions';
import { camDxVerifyError } from './action';
import { FormValues } from './view';

interface State {
  errors: Partial<FormValues>;
}

const initialState: State = {
  errors: {},
};

const reducer = handleActions(
  {
    [String(camDxVerifyError)]: (state, { payload }) => {
      return { ...state, errors: payload.errors };
    },
  },
  initialState,
);

export default reducer;
